// El selector de perfiles (ProfileManager, en NodesLayout) se muestra cuando la region tiene
// profiles_config.enable y el usuario aun no eligio perfil (localStorage 'selectProfile').
// Mismo criterio que useProfiles. /activacionhbo no monta NodesLayout: si el selector aun va a
// mostrarse, redirigir directo en el login saltaria la eleccion de perfil.
export const isProfileSelectionPending = profilesConfig => {
  if (!profilesConfig?.enable) return false;

  try {
    return !localStorage.getItem('selectProfile');
  } catch (error) {
    return false;
  }
};